import { EChartsCoreOption } from 'echarts';
import {
  ChartDataResponseResult,
  ChartProps,
  DataRecordValue,
  QueryFormColumn,
  QueryFormData,
  QueryFormMetric,
  SetDataMaskHook,
} from '@superset-ui/core';
import {
  DEFAULT_LEGEND_FORM_DATA,
  EchartsLegendFormData,
} from '../../../types';
import { LabelAlignment, LabelPosition } from '../enums';


export type EchartsPieFormData = QueryFormData &
  EchartsLegendFormData & {
    groupby: QueryFormData[];
    metric: QueryFormMetric;
    showLabels: boolean;
    tooltipFormat: string;
    labelPosition: LabelPosition;
    labelAlignment: LabelAlignment;
};

export interface EchartsPieChartProps
  extends ChartProps<EchartsPieFormData> {
  formData: EchartsPieFormData;
  queriesData: ChartDataResponseResult[];
}

// @ts-ignore
export const DEFAULT_FORM_DATA: EchartsPieFormData = {
  ...DEFAULT_LEGEND_FORM_DATA,
  groupby: [],
  showLabels: true,
  tooltipFormat: '{a} <br/>{b} : {c} ({d}%)',
  labelPosition: LabelPosition.Outer,
  labelAlignment: LabelAlignment.None,
};

export interface PieChartTransformedProps {
  formData: EchartsPieFormData;
  height: number;
  width: number;
  echartOptions: EChartsCoreOption;
  setDataMask: SetDataMaskHook;
  labelMap: Record<string, DataRecordValue[]>;
  groupby: QueryFormColumn[];
}